"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
// Define our map of matrix types to icons
const GenericIconMap = {
    'arrow-right': _1.ArrowRight,
    'arrow-down': _1.ArrowDown,
    'resource-select': _1.ResourceSelect,
    selected: _1.Selected,
    root: _1.Root,
    close: _1.Close,
    error: _1.Error,
    retry: _1.Retry,
    empty: _1.Empty,
    back: _1.Back,
};
// Export our map
exports.default = GenericIconMap;
